<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" label="报备流程" readonly />
			<van-field v-model="form.xmmc" label="项目名称" readonly />
			<van-field v-model="form.xmbh" label="项目编号" readonly />
			<van-field v-model="form.xmxh" label="项目型号" readonly />
			<van-field v-model="form.xmcchzmj" label="项目尺寸或总面积" readonly />
			<van-field v-model="form.xmdz" label="项目地址" readonly />
			<van-field v-model="form.bbgs" label="报备公司" readonly />
			<van-field v-model="form.sfgw" label="是否挂网" readonly />
			<van-field v-model="form.bbgsdjr" label="报备公司对接人" readonly />
			<van-field v-model="form.bbgsdjrdh" label="对接人电话" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "report",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {}
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				this.form = newV;
			}
		}
	}
};
</script>